import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { PropType, ref, computed, watchEffect, watch, onMounted, onUnmounted } from 'vue';
import { CheckboxListType } from '@/types';
import BaseModal from '@/components/BaseModal.vue';
import Accordion from '@/components/AccordionCheckbox.vue';
import ListSort from '@/components/ListSort.vue';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditCheckboxModal',
  props: {
  title: {
    type: String,
    default: 'タイトル',
  },
  list: {
    type: Array as PropType<CheckboxListType[]>,
    default() {
      return [];
    },
  },
  modelValue: {
    type: Array as PropType<string[]>,
    default() {
      return [];
    },
  },
  selectableMinNumber: {
    type: Number,
    defult: undefined, // undefinedの場合は最小選択個数の制限をしない
  },
  selectableMaxNumber: {
    type: Number,
    defult: undefined, // undefinedの場合は最大選択個数の制限をしない
  },
  hasNextPageType: {
    type: Boolean,
    defult: false,
  },
},
  emits: ["update:modelValue", "close"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string[]): void;
  (e: 'close'): true;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const value = ref(props.modelValue);
const modelValue = computed(() => props.modelValue);

onMounted(() => {
  const el = document.querySelector('body');
  if (el && !el.classList.contains('is-nonscroll')) {
    el.classList.add('is-nonscroll');
  }
});

onUnmounted(() => {
  const el = document.querySelector('body');
  if (el) {
    el.classList.remove('is-nonscroll');
  }
});

watchEffect(() => {
  value.value = modelValue.value;
});

watch(value, (newValue, oldValue) => {
  if (props.selectableMaxNumber !== undefined && newValue.length === props.selectableMaxNumber + 1 && newValue.length > oldValue.length) {
    store.dispatch('toasts/appendTimeToast', {
      label: props.title + 'は' + props.selectableMaxNumber + 'つまで選択できます',
      duration: null,
    });
  }
});

const close = () => {
  emit('close');
};
const clear = () => {
  value.value = [];
};

const isSortPage = ref(false);

const backFromSortPage = () => {
  isSortPage.value = false;
};
const decideSortPage = () => {
  emit('update:modelValue', value.value);
  close();
};
const decide = () => {
  emit('update:modelValue', value.value);
  if (props.hasNextPageType && value.value.length > 1) {
    isSortPage.value = true;
  } else {
    close();
  }
};

const rightBtnDisabled = computed(() => {
  return (
    (props.selectableMaxNumber !== undefined && value.value.length > props.selectableMaxNumber) ||
    (props.selectableMinNumber !== undefined && value.value.length < props.selectableMinNumber)
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    title: isSortPage.value ? 'メインキャリアの選択' : props.title,
    rightBtnDisabled: _unref(rightBtnDisabled),
    leftBtnText: isSortPage.value ? '戻る' : 'クリア',
    onClose: close,
    onLeftBtnClick: _cache[2] || (_cache[2] = ($event: any) => (isSortPage.value ? backFromSortPage() : clear())),
    onRightBtnClick: _cache[3] || (_cache[3] = ($event: any) => (isSortPage.value ? decideSortPage() : decide()))
  }, {
    default: _withCtx(() => [
      (isSortPage.value)
        ? (_openBlock(), _createBlock(ListSort, {
            key: 0,
            modelValue: value.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
            list: props.list
          }, null, 8, ["modelValue", "list"]))
        : (_openBlock(), _createBlock(Accordion, {
            key: 1,
            modelValue: value.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
            list: props.list
          }, null, 8, ["modelValue", "list"]))
    ]),
    _: 1
  }, 8, ["title", "rightBtnDisabled", "leftBtnText"]))
}
}

})